import { Turret } from "./Turret";
import { GameConstants } from "../GameConstants";
import { Enemy } from "../enemies/Enemy";
import { MathUtils } from "../utils/MathUtils";
import { Mortar } from "./shots/Mortar";
import { Engine } from "../Engine";

export class RocketsTurret extends Turret {

    public explosionRange: number;

    constructor (p: {r: number, c: number}, engine: Engine, skipBuild?: boolean, level?: number) {
        
        super(GameConstants.TURRET_ROCKETS, p, engine, skipBuild, level);

        this.calculateTurretParameters();

    }

    protected calculateTurretParameters(): void {

        this.damage = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_DAMAGE][this.level - 1];
        this.explosionRange = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_EXPLOSION_RANGE][this.level - 1];
        this.reload = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RELOAD][this.level - 1];
        this.range =  this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RANGE][this.level - 1];
        this.priceUpgrade =  this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_PRICE_UPGRADE][this.level - 1];

        this.projectileSpeed = GameConstants.MORTAR_SPEED;

        super.calculateTurretParameters();
    }

    protected getPathCellsInRange(): {r: number, c: number}[] {

        let cells = [];

        for (let i = 0; i < this.engine.enemiesPathsCells.length; i++) {
            for (let j = 0; i < this.engine.enemiesPathsCells[i].path.length; i++) {

                let cell = this.engine.enemiesPathsCells[i].path[j];

                if (cell.c >= this.position.c && cell.c <= this.position.c + this.range ||
                    cell.c <= this.position.c && cell.c >= this.position.c - this.range) {

                    if (cell.r >= this.position.r && cell.r <= this.position.r + this.range ||
                            cell.r <= this.position.r && cell.r >= this.position.r - this.range) {

                            cells.push(cell);
                    }
                }
            }
        }

        return cells;
    }

    protected shoot(): void {

        let enemy: Enemy;

        if (this.fixedTarget) {
            enemy = this.followedEnemy || this.enemiesWithinRange[0];
        } else {
            enemy = this.enemiesWithinRange[0];
        }

        let ticksToImpact: number;
        let impactPosition: {x: number, y: number};
        let d = this.range;

        let iterations = 2;

        if (enemy.type === GameConstants.ENEMY_ELECTRIC) {
            iterations = 3;
        } else {
            iterations = 2;
        }

        for (let i = 0; i < iterations; i ++) {
            ticksToImpact = Math.floor(d / this.projectileSpeed);
            impactPosition = enemy.getNextPosition(ticksToImpact);
            if (impactPosition) {
                d = MathUtils.fixNumber(Math.sqrt((this.x - impactPosition.x) * (this.x - impactPosition.x) + (this.y - impactPosition.y) * (this.y - impactPosition.y)));
            }
        }
    
        if (impactPosition) {
            const dx = impactPosition.x - this.x;
            const dy = impactPosition.y - this.y;
    
            this.shootAngle =  MathUtils.fixNumber(Math.atan2(dy, dx));
            const mortar = new Mortar(this.position, this.shootAngle, ticksToImpact, this.explosionRange, this.damage, this, this.engine);
    
            this.engine.addRocket(mortar, this);
        }
    }
}
